import bbox from "@turf/bbox";
import DefaultImg from "../../../assets/images/default.png";
import { LocalStorageKey } from "../../../constants/localStorageKeys";
import { ESttausCode } from "../../../enums";
import { showError, showSuccess } from "../../../helpers/toast";
import { addImgIntoCartAsync, delImgIntoCartAsync, getImgsAsync, setArrIdImage } from "../../../store/reducers/cartSlice";
import { setLoadingProvider } from "../../../store/reducers/searchSlice";
import { fetchImageBlob } from "../../../utils/imageRequest";
import { getImageCorners, resolveProviderCode } from "./imageFootprint";
import { MapAdapter } from "../MapAdapter/core/MapAdapter";
import { GEOJSON_FEATURE_COLOR_HOVER } from "../MapAdapter/layers/consts";
import { addLayer, removeLayer } from "../MapAdapter/store/slices/layerSlice";
import dayjs from "dayjs";

export function getThumbnail(links: any, baseUrl: string)
{

   // {
   //    "full_resolution_thumbnail": {
   //       "href": "s3://assets.satellitevu.com/high-res/20231208_161101_HS1_thumbnail.png",
   //          "roles": [
   //             "thumbnail"
   //          ],
   //             "type": "image/png"
   //    },
   //    "thumbnail": {
   //       "href": "https://assets.satellitevu.com/20231208_161101_HS1_degraded_thumbnail.png",
   //          "roles": [
   //             "thumbnail"
   //          ],
   //             "type": "image/png"
   //    }
   // }
   if (!links) return DefaultImg;

   // const t = links.find((l) => l.roles?.includes('thumbnail'));
   // console.log(t);

   // if (t?.sub_path && t?.sub_path !== "")
   // {
   //    return baseUrl + "/vmrs" + t.sub_path;
   // } else if (t?.href && t?.href !== "")
   // {
   //    return t.href;
   // } else
   // {
   //    return DefaultImg;
   // }

   if (links?.thumbnail)
   {
      return links?.thumbnail?.href
   }


}

export const flyToGeometry = (geometry: any, mapInstance: any) =>
{

   if (!geometry || !mapInstance) return;

   const bounds = bbox({
      type: "Feature",
      geometry,
      properties: {},
   });

   mapInstance.fitBounds(bounds, {
      padding: 40,
      duration: 1000,
   });
};

export const flyToGeometries = (geometries: any[], mapInstance: any) =>
{
   const valid = geometries.filter(Boolean);
   if (!valid.length || !mapInstance) return;

   const bounds = bbox({
      type: "FeatureCollection",
      features: valid.map((geometry) => ({ type: "Feature", geometry, properties: {} })),
   });

   mapInstance.fitBounds(bounds, {
      padding: 60,
      duration: 1000,
   });
};

export const getBBoxFromGeometry = (geometry: any): [number, number, number, number] =>
{
   if (!geometry || !geometry.coordinates) return [0, 0, 0, 0];

   const coords: number[][] = [];

   const extract = (arr: any) =>
   {
      if (typeof arr[0] === "number")
      {
         coords.push(arr);
      } else
      {
         arr.forEach(extract);
      }
   };

   extract(geometry.coordinates);

   let minX = Infinity;
   let minY = Infinity;
   let maxX = -Infinity;
   let maxY = -Infinity;

   coords.forEach(([x, y]) =>
   {
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
   });

   return [minX, minY, maxX, maxY];
};

export const getImage = async (thumbnailUrl: string) =>
{
   try
   {
      // No Authorization header when the image sits on the object store — that
      // host rejects the request outright when one is attached.
      const response = await fetchImageBlob(thumbnailUrl);

      if (response?.status === 200)
      {
         let contentType =
            response.headers && response.headers["content-type"]
               ? response.headers["content-type"]
               : "image/jpg";
         let blob = new Blob([response.data], {
            type: contentType,
         });

         if (blob.size != 0)
         {

            //@ts-ignore
            if (!window.navigator?.msSaveOrOpenBlob)
            {

               // BLOB NAVIGATOR
               return window.URL.createObjectURL(blob);
            } else
            {

               // BLOB FOR EXPLORER 11
               //@ts-ignore
               return window.navigator.msSaveOrOpenBlob(blob, contentType);
            }
         }
      }
   } catch (error)
   {
      // Fall through to the plain URL below: letting the map try it directly is
      // a better outcome than rejecting and leaving the layer half-loaded.
   }

   return thumbnailUrl;
};

export const getImageUrlAndCoordinates = async (item: any) =>
{
   const staticConfigs = JSON.parse(
      localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
   );
   const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
   const bboxFeature = getBBoxFromGeometry(item.geometry);

   const coordinates = [
      [bboxFeature[0], bboxFeature[3]],
      [bboxFeature[2], bboxFeature[3]],
      [bboxFeature[2], bboxFeature[1]],
      [bboxFeature[0], bboxFeature[1]],
   ];

   // let t = item?.links?.find((l: any) => l?.rel === "thumbnail");
   // const thumbnailUrl =
   //    t?.sub_path && t?.sub_path !== ""
   //       ? baseUrl + "/vmrs" + t?.sub_path
   //       : t?.href && t?.href !== ""
   //          ? t?.href
   //          : undefined;

   // if (!thumbnailUrl) return;

   const thumbnailUrl = getThumbnail(item?.assets, baseUrl);



   const imageUrl = await getImage(thumbnailUrl);



   return {
      imageUrl,
      coordinates,
   };
};



export interface ImageItem
{
   id: string;
   geometry: any;
   properties: Record<string, any>;
   bbox?: [number, number, number, number]
   /** Who took the image; more reliable than the provider a caller passes in. */
   provider_code?: string;
}

export interface MapLayerBase
{
   id: string;
   name: string;
   visible: boolean;
   visibility: boolean;
   opacity: number;
   zIndex: number;
}

export const showFootprint = (
   item: ImageItem,
   dispatch: any,
   mapInstance: any,
   skipFly = false,
) =>
{
   const base: MapLayerBase = {
      id: `footerprint-${item.id}`,
      name: item.id,
      visible: true,
      visibility: true,
      opacity: 1,
      zIndex: 100,
   };

   dispatch(
      addLayer({
         ...base,
         type: "geojson",
         geojsonData: {
            type: "FeatureCollection",
            features: [
               {
                  type: "Feature",
                  id: item.id,
                  geometry: item.geometry,
                  properties: item.properties ?? {},
               },
            ],
         },
      })
   );

   if (!skipFly) flyToGeometry(item.geometry, mapInstance);
};

export const removeFootprint = (item: ImageItem, dispatch: any) =>
{
   dispatch(removeLayer(`footerprint-${item.id}`));
};

export const panToImage = (
   item: ImageItem,
   mapInstance: any
) =>
{
   flyToGeometry(item.geometry, mapInstance);
};


// Refetch cart from BE so the sidebar total badge stays accurate
const refreshCartIds = async (dispatch: any) =>
{
   try
   {
      const res = await dispatch(getImgsAsync()).unwrap();
      if (res?.status === ESttausCode.OK)
      {
         dispatch(
            setArrIdImage(
               res?.data?.data?.items?.map((it: any) => it?.stac_item_id) ?? [],
            ),
         );
      }
   } catch
   {
      // ignore — keep previous local state
   }
};

export const addImagesToCart = async (
   ids: string[],
   dispatch: any,
   providerCode: string,
   idsImageInCart: string[],
   t: any
) =>
{
   dispatch(setLoadingProvider({ code: providerCode, value: true }));

   try
   {
      const res = await dispatch(
         // @ts-ignore
         addImgIntoCartAsync({
            stac_item_ids: ids,
         })
      ).unwrap();

      if (
         res?.status === ESttausCode.OK ||
         res?.status === ESttausCode.CREATED
      )
      {
         showSuccess(t("Add image to cart successfully"));

         // Refetch cart so the sidebar total updates from BE
         await refreshCartIds(dispatch);
      } else
      {
         // Show BE message (e.g. "User service timeout"); DO NOT refetch cart on failure.
         const msg = res?.response?.data?.message ?? res?.data?.message;
         showError(msg ? t(msg) : t("Add image to cart failed"));
      }
   } catch (error: any)
   {
      const msg = error?.response?.data?.message;
      showError(msg ? t(msg) : t("Add image to cart failed"));
   } finally
   {
      dispatch(setLoadingProvider({ code: providerCode, value: false }));
   }


};


export const removeImagesFromCart = async (
   ids: string[],
   dispatch: any,
   providerCode: string,
   idsImageInCart: string[],
   t: any
) =>
{
   dispatch(setLoadingProvider({ code: providerCode, value: true }));

   try
   {

      const res = await dispatch(
         // @ts-ignore
         delImgIntoCartAsync({
            cart_item_ids: ids,
         })
      ).unwrap();

      if (res?.status === ESttausCode.OK)
      {
         showSuccess(t("Delete image from cart successfully"));

         // Refetch cart so the sidebar total updates from BE
         await refreshCartIds(dispatch);
      } else
      {
         // Show BE message; DO NOT refetch cart on failure.
         const msg = res?.response?.data?.message ?? res?.data?.message;
         showError(msg ? t(msg) : t("Delete image from cart failed"));
      }
   } catch (error: any)
   {
      const msg = error?.response?.data?.message;
      showError(msg ? t(msg) : t("Delete image from cart failed"));
   }

   dispatch(setLoadingProvider({ code: providerCode, value: false }));
};

type LngLat = [number, number];
type BBox = [number, number, number, number]; // [west, south, east, north]

/**
 * Compute the geographic corners of an image after cropping out its
 * transparent / black padding. Returns 4 corners in order:
 *   [NW, NE, SE, SW]
 *
 * Optimizations vs. the previous impl:
 *  - 1 call to getImageData(0,0,w,h) instead of width*height*4 single-pixel reads.
 *  - 1 O(w*h) pass to compute the content bounding box instead of 4 separate scans.
 *  - Always resolves (null on error) — previous version left the promise pending
 *    when the image failed to load.
 */
const getNewCoordinates4ImageMap = (
   bbox: BBox | number[],
   imageLink: string,
): Promise<LngLat[] | null> =>
{
   return new Promise((resolve) =>
   {
      const corners: LngLat[] = [
         [bbox[0], bbox[3]], // NW
         [bbox[2], bbox[3]], // NE
         [bbox[2], bbox[1]], // SE
         [bbox[0], bbox[1]], // SW
      ];
      const lngSpan = Math.abs(corners[0][0] - corners[1][0]);
      const latSpan = Math.abs(corners[0][1] - corners[3][1]);

      const img = new Image();
      img.crossOrigin = "anonymous"; // allow getImageData on CORS-served images

      img.onerror = (err) =>
      {
         console.error("getNewCoordinates4ImageMap: image load failed", err);
         resolve(null);
      };

      img.onload = () =>
      {
         try
         {
            const width = img.naturalWidth || img.width;
            const height = img.naturalHeight || img.height;
            if (!width || !height)
            {
               resolve(corners);
               return;
            }

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            if (!ctx)
            {
               resolve(corners);
               return;
            }

            ctx.drawImage(img, 0, 0);

            // Single bulk read of pixel data (RGBA tuples, row-major).
            const { data } = ctx.getImageData(0, 0, width, height);

            // Single pass: find bbox of pixels that are opaque AND not pure black.
            let minX = width;
            let minY = height;
            let maxX = -1;
            let maxY = -1;

            for (let y = 0; y < height; y++)
            {
               const rowOffset = y * width * 4;
               for (let x = 0; x < width; x++)
               {
                  const i = rowOffset + x * 4;
                  const a = data[i + 3];
                  if (a === 0) continue;
                  if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0)
                  {
                     continue;
                  }
                  if (x < minX) minX = x;
                  if (x > maxX) maxX = x;
                  if (y < minY) minY = y;
                  if (y > maxY) maxY = y;
               }
            }

            // No content found → return the original bbox unchanged.
            if (maxX < 0 || maxY < 0)
            {
               resolve(corners);
               return;
            }

            const contentWidth = maxX - minX;
            const contentHeight = maxY - minY;
            if (contentWidth <= 0 || contentHeight <= 0)
            {
               resolve(corners);
               return;
            }

            // World-units per content pixel.
            const lngPerPx = lngSpan / contentWidth;
            const latPerPx = latSpan / contentHeight;

            // Padding around the content in pixels → degrees.
            const leftPad = minX * lngPerPx;
            const rightPad = (width - maxX) * lngPerPx;
            const topPad = minY * latPerPx;
            const bottomPad = (height - maxY) * latPerPx;

            // Expand outward so the geo bbox covers the original (padded) image.
            corners[0][0] -= leftPad;
            corners[3][0] -= leftPad;
            corners[1][0] += rightPad;
            corners[2][0] += rightPad;
            corners[0][1] += topPad;
            corners[1][1] += topPad;
            corners[2][1] -= bottomPad;
            corners[3][1] -= bottomPad;

            resolve(corners);
         } catch (error)
         {
            // Tainted canvas, OOM, etc.
            console.error("getNewCoordinates4ImageMap: canvas error", error);
            resolve(null);
         }
      };

      img.src = imageLink;
   });
};

export const showImageOnMap = async (
   item: ImageItem,
   dispatch: any,
   providerCode: string,
   mapInstance: any,
   skipFly = false,
) =>
{

   dispatch(setLoadingProvider({ code: providerCode, value: true }));

   const { imageUrl, coordinates } =
      (await getImageUrlAndCoordinates(item)) || {};

   let newCoordinates: any = coordinates;

   // Set when `newCoordinates` is already top-left, top-right, bottom-right,
   // bottom-left of the raster; otherwise the renderer works the order out from
   // the geography, which is only right for a north-up image.
   let cornersOrdered = false;

   const provider = resolveProviderCode(item, providerCode);

   if (provider === "planet")
   {
      try
      {
         const bboxFeature = item?.bbox || getBBoxFromGeometry(item.geometry);
         newCoordinates = await getNewCoordinates4ImageMap(
            bboxFeature,
            imageUrl
         );
      } catch (error) { }
   }

   else if (provider === "satvu")
   {
      try
      {
         newCoordinates = item?.geometry?.coordinates?.[0] || coordinates;
      } catch (error) { }
   }

   // ICEYE ships ground-range products: the raster is a rectangle tilted to the
   // flight path and the preview fills exactly that rectangle, so the image's
   // corners are the footprint's corners. Pinned to the bounding box instead, it
   // comes out square to north and 41% larger by area, spilling outside the very
   // footprint drawn next to it.
   //
   // These arrive already in image order, which matters: the raster's top-left
   // corner is not its north-west one, and sorting them geographically turns the
   // picture a quarter turn.
   else if (provider === "iceye")
   {
      const corners = getImageCorners(item);

      if (corners)
      {
         newCoordinates = corners;
         cornersOrdered = true;
      }
   }

   const base: MapLayerBase = {
      id: `image-${item.id}`,
      name: item.id,
      visible: true,
      visibility: true,
      opacity: 1,
      zIndex: 100,
   };

   dispatch(
      addLayer({
         ...base,
         type: "image",
         url: imageUrl,
         imageParams: {
            coordinates: newCoordinates,
            cornersOrdered,
            urlType: imageUrl,
         },
      })
   );

   if (!skipFly) flyToGeometry(item.geometry, mapInstance);

   dispatch(setLoadingProvider({ code: providerCode, value: false }));
};

export const removeImageFromMap = (
   item: ImageItem,
   dispatch: any
) =>
{
   dispatch(removeLayer(`image-${item.id}`));
};

export const mouseMoveItem = (
   item: ImageItem,
   engine?: MapAdapter | null
) =>
{
   if (!engine?.updateGeoJSONSource) return;

   const featureCollection: GeoJSON.FeatureCollection = {
      type: "FeatureCollection",
      features: [
         {
            type: "Feature",
            id: item.id,
            geometry: item.geometry,
            properties: {
               ...item.properties,
               color: GEOJSON_FEATURE_COLOR_HOVER,
            },
         },
      ],
   };

   engine.updateGeoJSONSource(
      `footerprint-${item.id}`,
      featureCollection
   );
};

export const mouseLeaveItem = (
   item: ImageItem,
   engine?: MapAdapter | null
) =>
{
   if (!engine?.updateGeoJSONSource) return;

   const featureCollection: GeoJSON.FeatureCollection = {
      type: "FeatureCollection",
      features: [
         {
            type: "Feature",
            id: item.id,
            geometry: item.geometry,
            properties: item.properties,
         },
      ],
   };

   engine.updateGeoJSONSource(
      `footerprint-${item.id}`,
      featureCollection
   );
};

export const checkTypeImageIncludeProvider = (imageType: any) =>
{
   if (!imageType) return [];

   return imageType?.providers ?? [];
};

const isDateField = (key: string) =>
{
   const k = key.toLowerCase();
   return (
      k.includes("date") ||
      k.includes("time") ||
      k.includes("start") ||
      k.includes("end")
   );
};

const isTimestamp = (value: any) =>
{
   if (typeof value === "number") return true;

   if (typeof value === "string" && /^\d+$/.test(value))
   {
      return true;
   }

   return false;
};

export const formatValue = (value: any, key?: string) =>
{
   if (value === null || value === undefined || value === "") return "-";

   // 👉 HANDLE TIMESTAMP
   if (key && isDateField(key) && isTimestamp(value))
   {
      const d = dayjs(Number(value));
      if (d.isValid()) return d.format("DD/MM/YYYY");
   }

   // 👉 RANGE DATE (string dạng a/b)
   if (typeof value === "string" && value.includes("/"))
   {
      const [start, end] = value.split("/");

      const startDate = dayjs(start);
      const endDate = dayjs(end);

      if (startDate.isValid() && endDate.isValid())
      {
         return `${startDate.format("DD/MM/YYYY")} - ${endDate.format("DD/MM/YYYY")}`;
      }
   }

   // 👉 ISO DATE
   if (typeof value === "string" && value.includes("T"))
   {
      const d = dayjs(value);
      if (d.isValid()) return d.format("DD/MM/YYYY");
   }

   return String(value);
};
export const formatKey = (key: string) =>
{
   return key
      .replace(/_/g, " ")                // bỏ _
      .replace(/\b\w/g, (char) => char.toUpperCase()); // viết hoa chữ cái đầu
};